import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { href: '#reserve', label: 'Reserve', sublabel: 'WEB予約' },
    { href: '#system', label: 'System', sublabel: '料金システム' },
    { href: '/shift', label: 'Shift', sublabel: '出勤情報', isRoute: true },
    { href: '#access', label: 'Access', sublabel: 'アクセス' },
    { href: '#notes', label: 'Notes', sublabel: '注意事項' },
  ];

  const handleAnchorClick = (href: string, isRoute?: boolean) => {
    setIsMenuOpen(false);
    if (isRoute) {
      window.REACT_APP_NAVIGATE(href);
    } else {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button onClick={() => handleAnchorClick('#reserve')} className="flex-shrink-0 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/7a6803503a084ffa064c71a8e4677aa3/cf44141841b9b36e73ca82220febca80.png"
              alt="JDスパ ロゴ"
              className="h-16 w-auto object-contain"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => handleAnchorClick(item.href, item.isRoute)}
                className="px-4 py-2 rounded-lg transition-all duration-200 text-center text-gray-700 hover:bg-pink-50 cursor-pointer"
              >
                <div className="text-sm font-semibold">{item.label}</div>
                <div className="text-xs text-gray-500">{item.sublabel}</div>
              </button>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:07089644442"
              className="flex items-center gap-2 px-5 py-3 bg-white border-2 border-pink-300 text-pink-500 rounded-full font-semibold hover:bg-pink-50 hover:shadow-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </div>
              070-8964-4442
            </a>
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-gradient-to-r from-pink-500 to-pink-400 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              WEB予約
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-pink-50 cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-pink-100">
          <nav className="px-4 py-4 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => handleAnchorClick(item.href, item.isRoute)}
                className="w-full text-left px-4 py-3 rounded-lg transition-all duration-200 text-gray-700 hover:bg-pink-50 cursor-pointer"
              >
                <div className="font-semibold">{item.label}</div>
                <div className="text-sm text-gray-500">{item.sublabel}</div>
              </button>
            ))}
            <a
              href="tel:07089644442"
              className="flex items-center gap-2 px-4 py-3 bg-pink-50 border border-pink-200 text-pink-500 rounded-lg font-semibold cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </div>
              070-8964-4442（電話受付）
            </a>
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 bg-gradient-to-r from-pink-500 to-pink-400 text-white rounded-lg font-semibold text-center cursor-pointer"
            >
              WEB予約
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}